import { defineStore } from "pinia";
import Network from "~/utils/network";

const urls = {
  onboarding: (countryId) => `/api/administration/onboarding/${countryId}?type=bnpl`,
};

export const useOnboardingStore = defineStore("onboarding", {
  state: () => ({
    steps: [],
  }),
  actions: {
    load: async function (countryId) {
      try {
        this.steps = await Network.http(urls.onboarding(countryId));
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
});
